import { createFormattersObject } from "../../helpers/utils";
import type { IPlotItem } from "../../containers/PlotsContainer";
import { useAvailableconjunctionHeaders } from "../../services/configuration";
import { PlotViewerCard } from "../plots/PlotViewerCard";
import { useFullscreenPanel } from "../useFullscreenPanel";
import { ConjunctionSummaryCard } from "./ConjunctionSummaryCard";
import type { ConjunctionRiskConfig } from "./conjunctionUiUtils";

interface ConjunctionPlotsPanelProps {
  conjunction: unknown;
  plots: IPlotItem[];
  riskConfig?: ConjunctionRiskConfig;
}

export const ConjunctionPlotsPanel = ({
  conjunction,
  plots,
  riskConfig,
}: ConjunctionPlotsPanelProps) => {
  const availableConjHeaders = useAvailableconjunctionHeaders();
  const formatters = createFormattersObject(availableConjHeaders.value);
  const { isFullscreen, toggleFullscreen } = useFullscreenPanel();

  return (
    <div className="flex h-full w-full min-h-0 overflow-hidden bg-slate-50/40 p-5 !pt-1">
      <section className="flex h-full min-h-0 w-full flex-col gap-5">
        {!isFullscreen && (
          <ConjunctionSummaryCard
            className="shrink-0"
            conjunction={conjunction}
            formatters={formatters}
            riskConfig={riskConfig}
          />
        )}

        <PlotViewerCard
          isFullscreen={isFullscreen}
          onToggleFullscreen={toggleFullscreen}
          plots={plots}
        />
      </section>
    </div>
  );
};
